import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { loggedInUserFragment } from "core/queries/GetLoggedInUser";
import {
  UpdateUser as UpdateUserGenerated,
  UpdateUserVariables as UpdateUserVariablesGenerated,
} from "core/queries/__generated__/UpdateUser";

export interface UpdateUserResponse extends UpdateUserGenerated {}
export interface UpdateUserVariables extends UpdateUserVariablesGenerated {}

export const updateUser = gql`
  mutation UpdateUser(
    $id: ID!
    $avatarId: ID
    $firstName: String
    $lastName: String
    $tomTeamMemberCityId: ID
  ) {
    updateUser(
      id: $id
      avatarId: $avatarId
      firstName: $firstName
      lastName: $lastName
      tomTeamMemberCityId: $tomTeamMemberCityId
    ) {
      user {
        id
        ...LoggedInUserFragment
      }
    }
  }
  ${loggedInUserFragment}
`;

interface UseUpdateUserQueryOptions {
  refetchQueries?: string[];
  awaitRefetchQueries?: boolean;
  onCompleted?: (data: UpdateUserResponse) => void;
}
export const useUpdateUser = ({
  refetchQueries = [],
  awaitRefetchQueries,
  onCompleted,
}: UseUpdateUserQueryOptions) =>
  useMutation<UpdateUserResponse, UpdateUserVariables>(updateUser, {
    refetchQueries,
    awaitRefetchQueries,
    onCompleted,
  });
